import { FC, lazy, Suspense } from 'react';
import styles from './Carousel.module.scss';
import CarouselNavigation from './CarouselNavigation/CarouselNavigation';
import WithDevice from '../../../common/WithDevice/WithDevice';
import { LABEL_KEYS } from '../../../../lib/constants/labelKeys';
import { Label } from '../../../common/Label/Label';
import useMobileExpanded from '../../../../lib/hooks/useMobileExpanded';
import { classes } from '../../../../lib/utils/cssUtils';
import { CarouselProps } from './Carousel.types';
import SkeletonCarousel from './SkeletonCarousel';

const SwiperCarousel = lazy(() => import('./SwiperCarousel'));

const Carousel: FC<CarouselProps> = ({ className, title, ariaLabel, showCarouselOnMobile, ...rest }) => {
  const { id, children, slidesPerView } = rest;
  const [showAllMobile, setShowAllMobile] = useMobileExpanded(false);
  const isChildrenArray = Array.isArray(children);
  const mobileSlidesCount = 3;

  if (children === undefined || !isChildrenArray) {
    return null;
  }

  const carouselElement = (
    <Suspense fallback={<SkeletonCarousel />}>
      <SwiperCarousel {...rest}>{children}</SwiperCarousel>
    </Suspense>
  );

  return (
    <div aria-label={ariaLabel} id={id} className={classes(styles.carouselWrapper, className)}>
      <div className={styles.headContainer}>
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {children.length > slidesPerView ? <CarouselNavigation /> : null}
      </div>
      <WithDevice mobile tablet>
        {showCarouselOnMobile ? (
          carouselElement
        ) : (
          <>
            <div>{showAllMobile ? children : children.slice(0, mobileSlidesCount)}</div>
            {!showAllMobile && children.length > mobileSlidesCount ? (
              <button onClick={() => setShowAllMobile(true)} className={styles.showMoreButton}>
                <Label name={LABEL_KEYS.CAROUSEL_BUTTON_MOBILE} /> ({children.length - mobileSlidesCount})
              </button>
            ) : null}
          </>
        )}
      </WithDevice>
      <WithDevice desktop>{carouselElement}</WithDevice>
    </div>
  );
};

export default Carousel;
